import { useEffect, useCallback } from 'react';
import { resetService } from '@/services/resetService';

interface UseKioskResetServiceOptions {
    isEnabled?: boolean;
    onZoomButtonsClose?: (isOpen: boolean) => void;
}

/**
 * Hook to integrate kiosk reset service with React components
 * This hook should be used in the main layout to automatically handle reset functionality
 */
export function useKioskResetService(options: UseKioskResetServiceOptions = {}) {
    // Configure the reset service
    useEffect(() => {
        resetService.configure(options);

        // Cleanup on unmount
        return () => {
            resetService.destroy();
        };
    }, [options.onZoomButtonsClose, options.isEnabled]); // Remove 'options' from dependency array

    // Return methods to control the reset service
    return {
        /**
         * Manually trigger reset countdown (useful for popup scenarios)
         */
        triggerResetCountdown: useCallback(() => {
            resetService.triggerResetCountdown();
        }, []),

        /**
         * Stop the current reset countdown
         */
        stopResetCountdown: useCallback(() => {
            resetService.stopResetCountdown();
        }, []),

        /**
         * Check if reset countdown is currently active
         */
        isResetActive: useCallback(() => {
            return resetService.isResetActive();
        }, []),
    };
}
